import { forwardRef, useEffect, useState } from 'react';
import { ProgressBarProps } from './ProgressBar.props';

import './ProgressBar.scss';
import clsx from 'clsx';

const ProgressBar = forwardRef<HTMLDivElement, ProgressBarProps>(
  ({ barStyle, className, percentage, ...rest }, ref) => {
    const [fixedPercentage, setFixedPercentage] = useState<number>(0);

    useEffect(() => {
      requestAnimationFrame(() => {
        setFixedPercentage(percentage ? Math.round(percentage * 100) / 100 : 0);
      });
    }, [percentage]);

    return (
      <div
        aria-label={rest['aria-label'] ?? `${fixedPercentage}%`}
        aria-valuemax={rest['aria-valuemax'] ?? 100}
        aria-valuemin={rest['aria-valuemin'] ?? 0}
        aria-valuenow={fixedPercentage}
        className={clsx('progress-bar-container', className)}
        ref={ref}
        role='progressbar'
        {...rest}
      >
        <span className='sr-only'>
          {rest['aria-label'] ?? `${fixedPercentage}%`}
        </span>
        <div
          aria-hidden='true'
          className='progress-bar-inner'
          style={{
            inlineSize: `${fixedPercentage}%`,
          }}
        />
      </div>
    );
  },
);

export default ProgressBar;
